{
  "archived_Desc_Key": "Meer hulp vind je hier.",
  "archived_Title_Key": "Dit document is gearchiveerd.",
  "carousel_Text_Key": "Was dit artikel niet wat je zocht? Probeer dan een van de onderstaande artikelen. ",
  "clear_button_label_Text_Key": "Zoekveld wissen",
  "click_prompt_Text_Key": "Klik hier",
  "close_Text_Key": "Sluiten",
  "customerService_Text_Key": "Klantendienst",
  "error_Text_Key": "Er ging iets mis",
  "faq": "Veelgestelde vragen",
  "feedback_Option1_Text_Key": "De tekst is verwarrend om te begrijpen",
  "feedback_Option2_Text_Key": "De tekst beantwoordt mijn vraag niet.",
  "feedback_Option3_Text_Key": "De tekst is relevant maar niet nuttig voor mij",
  "feedback_Option4_Text_Key": "De tekst is te lang of te kort ",
  "feedback_Question_1_Text_Key": "Welke specifieke onderdelen van onze artikelen vind je onbevredigend of niet behulpzaam?",
  "feedback_Rec_Text_Key": "Bedankt voor je feedback!",
  "feedback_Text_Key": "Was deze informatie nuttig? ",
  "here_Text_Key": "hier",
  "knowledge_Text_Key": "Kennis database",
  "link_prod_error_Text_Key": "https://ikea.marat.qd.je/be/nl/customer-service/track-manage-order/",
  "loading_Text_Key": "Laden",
  "market_Name_Key": "België",
  "modal_button_Close_Text_Key": "Sluiten",
  "negative_feedback_Text_Key": "Het spijt ons dat je niet het antwoord hebt gekregen dat je zocht, wil je ons helpen om dit te verbeteren?",
  "no_results_Text_Key": "We vonden geen resultaten voor {{query}}",
  "product_error_Text_Key": "Op zoek naar een product? Gebruik dan de zoekfunctie bovenaan de pagina. Als je de status van je bestelling wilt volgen, klik dan hier.",
  "read_more_button_Text_Key": "Lees meer",
  "results_Text_Key": "We vonden {{number}} resultaten voor: {{query}}",
  "retrieving_Text_Key": "Laden",
  "search_button_label_Text_Key": "Zoeken",
  "searchbar_Text_Key": "Typ een woord of zin, bijvoorbeeld \"bestellen\" of \"aanpassen\".",
  "searching_Text_Key": "Aan het zoeken...",
  "showLess_Text_Key": "Toon minder",
  "showMore_Text_Key": "Lees meer",
  "spellcheck_Text_Key": "Probeer het opnieuw met een andere spelling of trefwoorden",
  "submit_Text_Key": "Stuur  in",
  "try_again_Text_Key": "Probeer later opnieuw"
}